import React, { FC } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import ChatLayout from 'buyside/components/presentation/ChatLayout/chatLayout';
import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';
import QuickPositionsOverview from 'buyside/components/presentation/QuickPositionsOverview/quickPositionsOverview';
import { ChatContext } from 'buyside/components/presentation/ChatLayout/chatLayout';

import useQuickPositionNavigation from 'buyside/components/presentation/ChatLayout/ChatNavigation/useQuickPositionNavigation';

import { quickPositionsPageUrl } from 'buyside/util/urlHelper';

const QuickPositionsPageRoot: FC<{
  canManageMessages: string;
  canViewIdeas: string;
  currentUserId: string;
  hasPositions: string;
}> = ({ canManageMessages, canViewIdeas, currentUserId, hasPositions }) => {
  return (
    <ErrorBoundary pageName="quick positions">
      <Router basename={quickPositionsPageUrl()}>
        <Routes>
          <Route
            path="/:chatId?"
            element={
              <ChatContext.Provider
                value={{
                  canManageMessages: canManageMessages === 'true',
                  canViewIdeas: canViewIdeas === 'true',
                  currentUserId,
                  indexElement: (
                    <ErrorBoundary pageName="your quick positions overview">
                      <QuickPositionsOverview hasPositions={hasPositions === 'true'} />
                    </ErrorBoundary>
                  ),
                  useChatNavigation: useQuickPositionNavigation
                }}
              >
                <ChatLayout />
              </ChatContext.Provider>
            }
          />
        </Routes>
      </Router>
    </ErrorBoundary>
  );
};

export default QuickPositionsPageRoot;
